import { ContentBlocks } from "eddev/blocks"
import { defineView } from "eddev/views"
import { PageProvider } from "../contexts/PageContext"
import { CenteredBlocks } from "@components/site/CenteredBlocks"
import { SiteFooter } from "@components/site/SiteFooter"

export default defineView("single-news", (props) => {
  return (
    <PageProvider theme={"yellow"}>
      <CenteredBlocks contentBlocks={props.news?.contentBlocks} />
      <SiteFooter />
    </PageProvider>
  )
})
